import _ from 'underscore';
import flash from '../shared/flash';
import Utils from '../shared/utils';
import ContentManager from '../shared/content_managers/base';
import NodeContentViewer from '../shared/content_managers/node';
import SingleQuizContentViewer from '../shared/content_managers/quiz.single';
import BaseQuizViewer from '../shared/content_managers/quiz.base';
import BaseTaskViewer from '../shared/content_managers/task.base';
import BaseBlogViewer from '../shared/content_managers/blog.base';
import BaseRichTextViewer from '../shared/content_managers/rich_text.base';
import EvaluationViewer from '../shared/content_managers/evaluation';
import LegendContentViewer from '../shared/content_managers/legend';
import PasswordContentViewer from '../shared/content_managers/password';
import ChecklistViewer from '../shared/content_managers/checklist';
import Remote from '../shared/remote';
import { PreviewNodeRenderer } from '../shared/reactLoader';

export class PrivateBlogViewer extends BaseBlogViewer {
  constructor(context, remote, options) {
    super(context, remote, options);
    this.remote = new Remote('/learn/behaviors');
  }

  parseResult(result) {
    result.postDate = Utils.getDisplayableDate();
    return $(
      Handlebars.templates['behaviors/private_blog/viewer_preview'](
        $.extend(
          {
            node: {
              name: this.context.getName(),
              image: this.context.getImage(),
            },
          },
          { noCommunication: true, navigation: this.options.navigation },
          result,
        ),
      ),
    );
  }

  attach() {
    super.attach();
  }
}

export class PublicBlogViewer extends BaseBlogViewer {
  constructor(context, remote, options) {
    super(context, remote, options);
    this.remote = new Remote('/learn/behaviors');
  }

  parseResult(result) {
    return $(
      Handlebars.templates['behaviors/public_blog/viewer_preview'](
        $.extend(
          {
            node: {
              name: this.context.getName(),
              image: this.context.getImage(),
            },
          },
          { noCommunication: true, navigation: this.options.navigation },
          result,
        ),
      ),
    );
  }

  attach() {
    super.attach();
  }
}

export class CorrelationContentViewer extends LegendContentViewer {
  constructor(context, remote, options) {
    super(context, remote, options);
    this.remote = new Remote('/learn/behaviors');
  }

  findAnswers(result) {
    this.concepts = result.CorrelationList.Concepts;
    const answers_id = {};
    const answers_body = {};
    const answers = { answers_id, answers_body };
    let possible_answers = [];
    this.concepts.forEach((concept) => {
      possible_answers.push(concept.Description);
    });
    possible_answers = _.shuffle(possible_answers);
    return $.extend(answers, { possible_answers });
  }

  parseResult(result) {
    this.redoable = result.redoable;
    this.editable = true;
    return $(
      Handlebars.templates['behaviors/correlation/viewer_preview'](
        $.extend(
          {
            node: {
              name: this.context.getName(),
              image: this.context.getImage(),
            },
            noCommunication: true,
            navigation: this.options.navigation,
          },
          this.findAnswers(result),
          result,
        ),
      ),
    );
  }

  load() {
    return this.remote
      .get(this.options.getURLFor(ContentManager.Content.Correlation, this.context, this.options), { type: 'json' })
      .on('noAccess', () => {
        // Redirect to an url we want to return to after the login
        window.location.replace('/me');
      })
      .then((result) => {
        return this.parseResult(result);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  correct() {
    const cnt = this.panel.content;
    if (cnt.find('[data-concept-id]').length <= 0) {
      return;
    }
    let nr_of_questions = 0;
    let nr_of_correct = 0;

    cnt.find('[data-concept-id]').each((idx, element) => {
      nr_of_questions++;
      let correct_description_id = _.find(this.concepts, (concept) => {
        return $(element).attr('data-concept-id') == concept.id;
      }).Description.id;

      if (correct_description_id == $(element).attr('data-description-id')) {
        nr_of_correct++;
        $(element).find('.description-body').addClass('correct');
      }
    });

    // Display correct count
    let $correlation_result = cnt.find('.correlation-result');
    $correlation_result.children().remove();
    $correlation_result.append('<p>' + i18n.__('quiz_correction_result', nr_of_correct, nr_of_questions) + '</p>');

    if (!this.redoable) {
      this.editable = false;
      this.updateButtonStatus();
    }

    this.scramble_possible_answers();
  }

  updateButtonStatus() {
    let all_answered = true;
    this.panel.content.find('.lp--js-pickConceptOption').each((idx, element) => {
      all_answered = $(element).attr('data-description-id') != '' && all_answered;
    });

    if (all_answered && this.editable) {
      this.panel.content.find('.js-btn-correct').removeClass('disabled').removeAttr('disabled');
    } else {
      this.panel.content.find('.js-btn-correct').addClass('disabled').attr('disabled', 'disabled');
    }
  }

  scramble_possible_answers() {
    const $possible_list = $('.possible-list');

    const shuffle = function (o) {
      for (let j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
      return o;
    };

    const elems = shuffle($possible_list.first().children());
    $possible_list.children().detach('.possible-option');

    for (let i = 0; i < elems.length; i++) {
      $possible_list.append(elems[i]);
    }
  }

  pick_description(e) {
    e.preventDefault();
    const description_id = $(e.currentTarget).find('.description-body').eq(0).attr('data-description-id');
    const $locationElement = $(e.target).parents('.lp--js-pickConceptOption').eq(0);
    const $locationText = $locationElement.find('.lp--js-pickedConceptOption').eq(0);

    if (!description_id) {
      // Do not drop placeholders on stuff
      return;
    }
    $('.description-body').removeClass('correct');

    $(`.lp--js-pickConceptOption[data-description-id='${description_id}'] .lp--js-pickedConceptOption`).html(
      `<p>${i18n.__('correlation_no_desc_chosen')}</p>`,
    );
    $(`.lp--js-pickConceptOption[data-description-id='${description_id}']`).attr('data-description-id', '');

    $locationElement.attr('data-description-id', description_id);
    $locationText.html(`<p>${$(e.currentTarget).find('.description-body').eq(0).text()}</p>`);

    $('.lp--answerPicker').hide();

    this.updateButtonStatus();
  }

  attach() {
    super.attach();

    $('.lp--js-pickedConceptOption').html(`<p>${i18n.__('correlation_no_desc_chosen')}</p>`);

    this.panel.content.on(Utils.interactionEvent, (e) => {
      this.panel.content.find('.lp--answerPicker').hide();
    });

    this.panel.content.find('.lp--js-pickConceptOption').on(Utils.interactionEvent, (e) => {
      e.stopPropagation();
      this.panel.content.find('.lp--answerPicker').hide();
      let $answerPicker = $(e.currentTarget).find('.lp--answerPicker');
      $answerPicker.find('.possible-option').removeClass('used');
      $answerPicker.find('.possible-option').each((i, el) => {
        const descId = $(el).find('.description-body').eq(0).attr('data-description-id');
        if ($(`.lp--js-pickConceptOption[data-description-id='${descId}']`).length > 0) {
          $(el).addClass('used');
        }
      });
      $answerPicker.show();
    });

    this.panel.content.find('.lp--answerPicker').on(Utils.interactionEvent, (e) => {
      e.stopPropagation();
    });

    this.panel.content.find('.possible-option').on(Utils.interactionEvent, (e) => {
      this.pick_description(e);
    });

    this.panel.content.find('.js-btn-correct').on('keypress ' + Utils.tapInteractionEvent + '.correlation', (ev) => {
      this.correct();
    });
  }
}

export class PreviewLegendContentViewer extends LegendContentViewer {
  constructor(context, remote, options) {
    super(context, remote, options);
  }

  parseResult(content) {
    return $(
      Handlebars.templates['behaviors/legend/viewer_preview'](
        $.extend(
          {
            node: {
              name: this.context.getName(),
              image: this.context.getImage(),
            },
            noCommunication: true,
            navigation: this.options.navigation,
          },
          content,
        ),
      ),
    );
  }

  attach() {
    super.attach();
  }
}

export class QuizContentViewer extends SingleQuizContentViewer {
  parseResult(content) {
    content.preview = true;
    this.data = content;
    let result = {
      cnt: $(
        Handlebars.templates['behaviors/quiz/viewer_preview'](
          $.extend(
            {
              navigation: this.options.navigation,
              noCommunication: true,
              node: {
                name: this.context.getName(),
                image: this.context.getImage(),
              },
            },
            content,
          ),
        ),
      ),
    };
    return result;
  }

  attach() {
    super.attach();
  }
}

export class WrittenQuizContentViewer extends BaseQuizViewer {
  constructor(context, remote, options) {
    super(context, remote, options);
    this.type = 'written_quiz';
  }

  parseResult(result) {
    let templatePath = 'behaviors/quiz/viewer_preview';
    if (result.type == 'written_quiz') {
      templatePath = 'behaviors/written_quiz/viewer_preview';
    }
    return {
      cnt: $(
        Handlebars.templates[templatePath](
          $.extend(
            {
              node: {
                name: this.context.getName(),
                image: this.context.getImage(),
              },
              questions: result.QuizQuestions,
            },
            { noCommunication: true, navigation: this.options.navigation },
            result,
          ),
        ),
      ),
      role: result.role,
    };
  }

  setupModal(modal) {
    super.setupModal(modal);
    modal.eventSource.one('shown.modal', () => {
      this.attach();

      this.questionCount = this.modal.content.find('.question').length;
    });

    return modal;
  }

  attach() {
    if (this.options.features.useNewWrittenQuizNode) {
      PreviewNodeRenderer.render(this.context.id, this.type, this.options.navigation, this.panel);
      return;
    }

    super.attach();
  }
}

export class TaskContentViewer extends BaseTaskViewer {
  constructor(context, remote, options) {
    super(context, remote, options);
    this.type = 'task';
  }

  parseResult(result) {
    var cnt = $(
      Handlebars.templates['behaviors/task/viewer_preview'](
        $.extend(
          {
            node: {
              name: this.context.getName(),
              image: this.context.getImage(),
            },
            handin: null,
            requireSession: false,
            noCommunication: true,
            navigation: this.options.navigation,
            handin_possible: false,
          },
          result,
        ),
      ),
    );
    return cnt;
  }

  attach() {
    if (this.options.features.useNewTaskNode) {
      PreviewNodeRenderer.render(this.context.id, this.type, this.options.navigation, this.panel);
      return;
    }
    super.attach();
  }
}

export class EvaluationPreviewViewer extends EvaluationViewer {
  parseResult(result) {
    var cnt = $(
      Handlebars.templates['behaviors/evaluation/viewer_preview'](
        $.extend(
          {
            node: {
              name: this.context.getName(),
              image: this.context.getImage(),
            },
            handin: null,
            requireSession: false,
            navigation: this.options.navigation,
            noCommunication: true,
            handin_possible: false,
          },
          result,
        ),
      ),
    );
    return { cnt: cnt, documents: result.documents };
  }

  attach() {
    super.attach();
  }
}

// Yes, this inherits from BaseTaskViewer by design - the task-related implementations
// can probably share a superclass, and if so - they should. Consider BaseGroupViewer
// to be flagged for deprecation.
export class GroupContentViewer extends BaseTaskViewer {
  parseResult(result) {
    let cnt = $(
      Handlebars.templates['behaviors/group/viewer_preview'](
        $.extend(
          {
            node: {
              name: this.context.getName(),
              image: this.context.getImage(),
            },
            requireSession: false,
            navigation: this.options.navigation,
            noCommunication: true,
          },
          result,
        ),
      ),
    );
    return cnt;
  }

  attach() {
    super.attach();
  }
}

export class RichTextContentViewer extends BaseRichTextViewer {
  constructor(context, remote, options) {
    super(context, new Remote('/learn/preview'), options);
    this.type = 'chunk';
  }

  parseResult(result) {
    let json_result = JSON.parse(result);

    var cnt = $(
      Handlebars.templates['rich_text_content']({
        name: this.context.getName(),
        image: this.context.getImage(),
        uuid: this.context.getId(),
        type: this.context.getType(),
        titleKey: `chunk_type_${this.context.getType()}`,
        content: json_result.html,
        noCommunication: true,
        navigation: this.options.navigation,
        requireSession: false,
      }),
    );

    return { cnt: cnt };
  }

  setupModal(panel, data) {
    super.setupModal(panel);
    panel.eventSource.one('added.panel', () => {
      this.attach();
    });

    panel.eventSource.one('didHide.panel', () => {
      this.detach();
    });

    return panel;
  }

  attach() {
    if (this.options.features.useNewArticleNode) {
      PreviewNodeRenderer.render(this.context.id, this.type, this.options.navigation, this.panel);
      return;
    }
    super.attach();
  }
}

export class PreviewPasswordContentViewer extends PasswordContentViewer {
  validatePassword() {
    let pwd = this.panel.content.find('.lp--js-passwordPanelInput').val();
    let data = this.options.node.data();
    return new Promise((resolve, reject) => {
      if (pwd == data.code) {
        this.options.node.data('lock_state', 'unlocked');
        this.options.onResolve(this.options.node);
        flash(i18n.__('node_unlock_success'), { ttl: 3000, type: 'status' });
      } else {
        flash(i18n.__('node_unlock_failed'), { ttl: 3000 });
      }
    });
  }
}

export class ChecklistContentViewer extends ChecklistViewer {
  constructor(context, remote, options) {
    super(context, remote, options);
    this.type = 'checklist';
  }

  attach() {
    PreviewNodeRenderer.render(this.context.id, this.type, this.options.navigation, this.panel);
  }
}

ContentManager.Implementations = {
  legend: PreviewLegendContentViewer,
  correlation: CorrelationContentViewer,
  private_blog: PrivateBlogViewer,
  public_blog: PublicBlogViewer,
  quiz: QuizContentViewer,
  written_quiz: WrittenQuizContentViewer,
  task: TaskContentViewer,
  group: GroupContentViewer,
  chunk: RichTextContentViewer,
  video: RichTextContentViewer,
  link: RichTextContentViewer,
  rich: RichTextContentViewer,
  evaluation: EvaluationPreviewViewer,
  checklist: ChecklistContentViewer,
  default: NodeContentViewer,
};
